import { AfterViewInit, Component, inject } from '@angular/core'
import { Navbar } from '../../../common/navbar/navbar.component'
import { Modal } from 'bootstrap'
import { Volunteer } from '../../../../modal/person.modal'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { AuthService } from '../../../../services/auth.service'
import { ClassService } from '../../../../services/class.service'
import { map } from 'rxjs'
import { commonUtil } from '../../../../utils/common.util'

interface ClassAttendenceVolunteer {
  volunteer: Volunteer
  isAttendanceControl: FormControl<string>
}

@Component({
  selector: 'app-volunteer-attendance',
  imports: [Navbar, ReactiveFormsModule, TranslatePipe],
  templateUrl: './volunteer-attendance.component.html',
  styleUrl: './volunteer-attendance.component.css'
})
export class VolunteerAttendance implements AfterViewInit {
  private authService = inject(AuthService)
  private classService = inject(ClassService)
  private translateService = inject(TranslateService)
  private modal: Modal | undefined
  private classId?: number
  private currentUserId?: number
  private changedVolunteers: Set<ClassAttendenceVolunteer> = new Set()
  volunteers?: ClassAttendenceVolunteer[]
  isLoading = true
  isUpdating = false

  hide() {
    this.modal?.hide()
  }

  show(classId: number) {
    this.classId = classId
    this.currentUserId = this.authService.getCurrentUser()?.id
    this.getVolunteers()
    this.modal?.show()
  }

  mapAttendanceVolunteer(vol: Volunteer) {
    let control = new FormControl(vol.isAttendance ?? '')
    let atteVolu = {
      volunteer: vol,
      isAttendanceControl: control
    } as ClassAttendenceVolunteer
    control.valueChanges.subscribe((val) => {
      if (vol.isAttendance === val) {
        this.changedVolunteers.delete(atteVolu)
        return
      }

      this.changedVolunteers.add(atteVolu)
    })
    return atteVolu
  }

  getVolunteers() {
    if (!this.classId) {
      return
    }
    this.isLoading = true
    this.volunteers = []
    this.changedVolunteers.clear()
    this.classService
      .getClassVolunteers(this.classId)
      .pipe(
        map((vols: Volunteer[]) =>
          vols
            .filter((vol) => !vol.isCoach && vol.id !== this.currentUserId)
            .map((vol) => this.mapAttendanceVolunteer(vol))
        )
      )
      .subscribe({
        next: (vols) => {
          this.isLoading = false
          this.volunteers?.push(...vols)
        },
        error: () => (this.isLoading = false)
      })
  }

  isAttendanceSet(vol: ClassAttendenceVolunteer) {
    return vol.volunteer.isAttendance !== null && vol.volunteer.isAttendance !== undefined
  }

  allAttendanceSet() {
    return this.volunteers?.every((vol) => this.isAttendanceSet(vol)) ?? false
  }

  disableUpdate() {
    return this.changedVolunteers.size === 0 || this.isLoading || this.isUpdating
  }

  resetRadio(event: Event, control: FormControl) {
    let el = event.target as HTMLInputElement
    if (control.value === el.value) {
      control.setValue('none')
    }
  }

  updateVolunteersAttendance() {
    if (!this.classId) {
      return
    }

    if (this.changedVolunteers.size === 0) {
      commonUtil.alert(
        this.translateService.instant(
          'app.volunteerAttendance.attendanceUpdateSuccessfully'
        ),
        'success'
      )
      return
    }

    this.isUpdating = true
    let updateVolunteers: Volunteer[] = []
    this.changedVolunteers.forEach((val) => {
      updateVolunteers.push({
        id: val.volunteer.id,
        isAttendance: val.isAttendanceControl.value
      })
    })
    this.classService
      .updateVolunteersAttendance(this.classId, updateVolunteers)
      .subscribe({
        next: (success) => {
          this.isUpdating = false
          if (success) {
            this.getVolunteers()
            commonUtil.alert(
              this.translateService.instant(
                'app.volunteerAttendance.attendanceUpdateSuccessfully'
              ),
              'success'
            )
          }
        },
        error: () => (this.isUpdating = false)
      })
  }

  ngAfterViewInit(): void {
    this.modal = Modal.getOrCreateInstance('#volunteerAttendance')
  }
}
